import Chat from './Chat/Chat';

function ItemChat({ item }) {
    const { messages, participants } = item;

    return <Chat messages={messages} participants={participants}></Chat>;
}

export default ItemChat;
